import styles from './home.module.scss';
import ComputerImage from '../../assets/comp.png';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';


const Home = () => {
	const [t, i18n] = useTranslation();
	console.log('i18n', i18n.language
	)
	return (
		<section id="home" className={styles.container}>
			<div className={styles.content_wrapper}>
				<div className={styles.text_wrapper}>
					<h5>
						<b>{t('section.home.title')}</b>
					</h5>
					<h1 className={styles.title}>
					{t('section.home.subTitle1').toUpperCase()}<b>{t('section.home.subTitle2').toUpperCase()}</b>
					</h1>
					<p>
					{t('section.home.description1')}<b>{t('section.home.description2')}</b> {t('section.home.description3')}
					</p>
				</div>
				<img
					className={styles.image}
					alt={t('section.home.noImage')}
					src={ComputerImage}
				/>
			
			</div>
			{i18n.language === 'es' ? <Link to='/download-ebook' className={styles.ebook_link}>Descarga Nuestro Ebook</Link> : null}
		</section>
	);
};

export default Home;
